import Swiper from 'swiper/bundle';

export default () => {
  if(document.querySelector('.category-grid__block')){

    var swiperGrid = Swiper;
    var init = false;

    swiperMode();
  
    window.addEventListener('resize', function() {
      swiperMode();
    });

    function swiperMode() {
      let mobile = window.matchMedia('(min-width: 0px) and (max-width: 640px)');
      let largeDevice = window.matchMedia('(min-width: 641px)');

      if(mobile.matches) {
        if (!init) {
          init = true;
          swiperGrid = new Swiper('.category-grid__block', {
            slidesPerView: 1,
            freeMode: true,
            mousewheel: false,
            navigation: {
                nextEl: document.querySelector('.category-grid .card-slider__button-next'),
                prevEl: document.querySelector('.category-grid .card-slider__button-prev'),
              },
            breakpoints: {
              641: {
                slidesPerView: 'auto',
                navigation: false,
              }
            }
          });
        }
      } else if(largeDevice.matches) {
        if (init) {
          swiperGrid.destroy();
          init = false;
        }
      }
    }
  }
}